<template>
  <validation-observer ref="form" tag="div">
    <shrimp-quality-modal></shrimp-quality-modal>
    <component
        v-bind:is="model.active_form_component"
        v-if="!lodash.isEmpty(model)"
        v-model="model"
    />
  </validation-observer>
</template>

<script>
import FormModel from './model';
import CustomerCreateModal from '../modals/customer-create';
import EditFormAfterPayment from './purchase_orders/edits/after-payment'
import EditFormBeforePayment from './purchase_orders/edits/before-payment'
import ShrimpQualityModal from '../modals/shrimp-quality-modal';

export default {
  extends: FormModel,
  components: {
    CustomerCreateModal,
    EditFormAfterPayment,
    EditFormBeforePayment,
    ShrimpQualityModal,
  },
  data() {
    return {
      model: {
        active_form_component: null,
        total: 0,
        service_fee: 0,
        mark_up: 0,
        send_to_rfq: true,
        ...this.value,
        ice_cost: this.value?.purchase_operational_costs?.find(({name}) => name.toLowerCase() === 'ice')?.amount || 0,
        shipping_cost: this.value?.purchase_operational_costs?.find(({name}) => name.toLowerCase() === 'delivery')?.amount || 0,
        labour_cost: this.value?.purchase_operational_costs?.find(({name}) => name.toLowerCase() === 'labour')?.amount || 0,
        unit_duration: "days",
        // files: [
        //   ...((this.value.files || []).length ? this.value.files : [{}]),
        // ],
        files: [
          ...((this.value.files || []).length ? this.value.files :
              [{name: 'invoice document'}, {name: 'down payment document'}]),
        ],
        purchase_items: [
          ...((this.value.purchase_items || []).length ? this.value.purchase_items : [{}]),
        ],
        purchase_additional_items: [
          ...((this.value.purchase_additional_items || []).length ? this.value.purchase_additional_items : []),
        ],
        additional_fees: [
          ...((this.value.purchase_additional_fees || []).length ? this.value.purchase_additional_fees : []),
        ],
        discounts: [
          ...((this.value.purchase_discounts || []).length ? this.value.purchase_discounts : []),
        ],
        operational_costs: [
          ...(this.value.purchase_operational_costs?.length ? this.value.purchase_operational_costs.map(v => ({
            ...v,
            total: v.amount
          })) : [])
        ],
        other_operational_costs: [
          ...(
              this.value.purchase_operational_costs?.filter(({name}) => !['delivery', 'labour', 'ice'].includes(name.toLowerCase()))?.length ?
                  this.value.purchase_operational_costs?.filter(({name}) => !['delivery', 'labour', 'ice'].includes(name.toLowerCase())).map(v => ({
                    ...v,
                    total: v.amount
                  })) : []
          )
        ],
        ticket: !this.lodash.isEmpty(this.value.ticket) ? this.value.ticket : {},
        ticketable: {
          ...(!this.lodash.isEmpty(this.value.ticketable) ? this.value.ticketable : {ticket_id: null})
        },
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document) ? this.value.invoice_document : {name: 'down payment document'},
        down_payment_document: !this.lodash.isEmpty(this.value.down_payment_document) ? this.value.down_payment_document : {name: 'down payment document'},
        initial_type: this.value.type,
        operational_cost_document: !this.lodash.isEmpty(this.value.operational_cost_document) ? this.value.operational_cost_document : {name: 'operational cost document'},
        shrimp_selected: this.value.product,
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.$set(this.model, 'active_form_component', this.activeFormComponent)
      }
    }
  },
  computed: {
    activeFormComponent() {
      if (this.value.is_fully_billed) {
        return 'edit-form-after-payment'
      }
      if (['hybrid', 'down_payment'].includes(this.value.type)) {
        return 'edit-form-before-payment'
      }

      return this.value.is_stock_used ? 'edit-form-after-payment' : 'edit-form-before-payment'
    }
  }
}
</script>

<style scoped>
.delete-item {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>